import auth from '../../services/auth'
import MessageDialog from '../../components/message-dialog.vue'

export default {

  data() {
    return {
      password: undefined,
      oldPassword: undefined,
      passwordRepeat: undefined,
      errorMessage: undefined,
      loading: undefined,

      password: null,
      passwordLength: 0,
		  containsEightCharacters: false,
      containsNumber: false,
      containsUppercase: false,
		  containsSpecialCharacter: false,
      validPassword: false
    }
  },
  methods: {
    doRequest() {
      this.loading = auth.requestChangePassword(auth.getTaxIdNumber().replace(/[.\-\/]/g, '').toUpperCase()).
      then(resp => {
        //if (resp.data.status.code === 0) {
        if (resp)   
        this.$router.push({name: '2fa-interno',
      params: {type: 'UPDATE_PASSWORD'}});
        //}
      }).catch(err => {
        this.formState = 'ERROR';
          console.log('erro: ', err.data.status.message);
            this.errorMessage = err.data.status.message;
      });
    },
    doChange() {
      /** const hash = window.location.hash;
      auth.saveHash(hash);
      const is2FAResetPassWord = hash.includes('requerer-senha/desbloqueioConta');
      **/
      this.$validator.validateAll()
        .then((success) => {
          this.loading = auth.changePassword(this.oldPassword, this.password)
          .then((value) => {
            if (value)
              return MessageDialog.show({
                headerClass: 'modal-success',
                title: 'Definição de senha',
                message: 'Sua senha foi alterada com sucesso!',
                type: 'OK'
              }).then(() => {
                this.$router.push({name: 'plans', 
                //params:{type: redirectParams}
              });
              })

          }).catch((error) => {
              this.errorMessage = error.data && error.data.status && error.data.status.message || "Erro do servidor.";
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/password-change-confirmation.js